import React, {Fragment, PureComponent} from 'react'
import styles from './styles'
import {
  FormContext, OptionalInput, YesNoRadio, CountrySelect, MultiCountrySelect, ReadOnly,
  FileUploadField, LinkButton
} from 'components'
import {Typography, Button, TextField, IconButton} from 'components/OptimisedMui'
import DeleteIcon from '@material-ui/icons/Delete';
import { paramScoped, uuid } from 'utils'
import Collapse from '@material-ui/core/Collapse'

export class Legal extends PureComponent {
  static defaultProps = {
    name: 'Legal',
    title: 'Legal information',
  }

  state = {
    tncsHelpOpen: false,
    tncsPreview: '',
  }

  handleAddAdviser = () => {
    const {context} = this.props
    this.props.onChange({...context, legalAdvisers: [...context.legalAdvisers, {key: uuid()}]})
  }

  handleDeleteAdviser = paramScoped(adviser => event => {
    const {onChange, context} = this.props
    onChange({...context, legalAdvisers: context.legalAdvisers.filter(a => a !== adviser)})
  })

  handleAddDocument = () => {
    this.props.onStageChange(3)
  }

  deleteIcon = <DeleteIcon/>

  render = () => {
    const {onChange, context, errorContext, countries, groups, review} = this.props
    const [isUtility, isSecurity, isEquity] = [context.typeOfIssuance === 'utility', context.typeOfIssuance === 'security', context.typeOfIssuance === 'equity']
    return (
      <ReadOnly on={review}>
        <FormContext
          onChange={onChange}
          context={context}
          errorContext={errorContext}
          metaRef={this.props.metaRef}
        >

          {(isUtility || isSecurity) &&
            <div className={styles.section}>
              <Typography variant='h6'>Will the token be exchange listed?</Typography>
              <YesNoRadio member="exchangeTokenListed" name="exchangeTokenListed1"/>
            </div>
          }

          {isUtility &&
            <div className={styles.section}>
              <Typography variant='h6'>Will the token be issued by the same entity that is running the ICO?</Typography>
              <YesNoRadio member="tokenIssuedByIcoRunner" name="tokenIssuedByIcoRunner1"/>
            </div>
          }

          <div className={styles.section}>
            <Typography variant='h6'>{isUtility ? 'Where is the company registered?' : 'What jurisdiction are you situated in?'}</Typography>
            <CountrySelect member="issuingJurisdictionId" label="Country" countries={countries} fullWidth required/>
            <TextField member="companyInfo.registeredAddress" fullWidth />
            <TextField member="companyInfo.businessAddress" label="Business Address (if different, no PO boxes)" fullWidth />
          </div>

          <div className={styles.section}>
            <Typography variant='h6'>Certificate of incorporation</Typography>
            <Typography variant="body1" paragraph>Supported file type: .PDF, .JPG, .GIF or .PNG</Typography>
            <FileUploadField member="companyInfo.certificationOfIncorporation" meta={{prepopulated: true}} />
          </div>

          <div className={styles.section}>
            <TextField member="companyInfo.typeOfLegalEntity" label={`What type of legal or corporate structure is being used to issue the ${isEquity ? 'equity' : 'tokens'}?`} fullWidth/>
            <TextField member="companyInfo.legalName" label={`What is the registered company/foundation name of the entity that will issue the ${isEquity ? 'equity' : 'tokens'}?`} fullWidth required/>
            <TextField member="companyInfo.placeOfFormation" fullWidth/>
            {isUtility &&
            <Fragment>
              <TextField member="companyInfo.natureOfBusiness" fullWidth/>
              <TextField member="companyInfo.sourceOfFunds" fullWidth/>
              <TextField member="companyInfo.websiteUrl" label="Company Website" fullWidth/>
            </Fragment>
            }
          </div>

          {isUtility &&
            <Fragment>
              <div className={styles.section}>
                <Typography variant='h6'>Have you received a legal opinion confirming that your token is a utility or security token?</Typography>
                <OptionalInput member="hasLegalOpinion">
                  <LinkButton className={styles.linkButton} onClick={this.handleAddDocument}>Attach Document</LinkButton>
                </OptionalInput>
              </div>

              <div className={styles.section}>
                <Typography variant='h6'>Primary Contact</Typography>
                <TextField member='companyInfo.primaryContactName' label='Name' fullWidth/>
                <TextField member='companyInfo.primaryContactPhoneNumber' label='Phone Number'/>
                <TextField member='companyInfo.primaryContactEmailAddress' label='Email Address'/>
              </div>

              <div className={styles.section}>
                <Typography variant='h6'>Stakeholders</Typography>
                <Typography variant="subtitle1">Please list names for the following:</Typography>
                <TextField member='companyInfo.nameOfShareholders' label='Persons (ultimate shareholders) that own 25% or more of the entity' fullWidth/>
                <TextField member='companyInfo.namesOfDirectors' label='Directors' fullWidth/>
                <TextField member='companyInfo.namesOfOfficers' label='Officers' fullWidth/>
              </div>

              <div className={styles.section}>
                <Typography variant='h6'>Name of legal advisers/counsel to the project</Typography>
                {context.legalAdvisers.map((adviser, i) =>
                  (adviser._destroy) ? null :
                  <Fragment key={adviser.key}>
                    <TextField member={`legalAdvisers[${i}].name`} errorMember={`legalAdvisers['${adviser.key}'].name`}
                               meta={{errorLabel: 'Legal Adviser Name of Firm'}} label="Name of firm" />
                    <TextField member={`legalAdvisers[${i}].address`} errorMember={`legalAdvisers['${adviser.key}'].address`}
                               meta={{errorLabel: 'Legal Adviser Contact Address'}} label="Contact address" />
                    {(i !== 0) &&
                      <IconButton className={styles.itemDelete} onClick={this.handleDeleteAdviser(adviser)}>{this.deleteIcon}</IconButton>
                    }
                  </Fragment>
                )}
              </div>
              <div className={styles.section}>
                <Button variant="contained" className={styles.addButton} onClick={this.handleAddAdviser} fullWidth>Add Another Adviser</Button>
              </div>
            </Fragment>
          }

          <div className={styles.section}>
            <Typography variant='h6'>
              Do you intend to only allow whitelisted investors to participate in
              your {isEquity ? 'equity raise' : 'token sale'}?
            </Typography>
            <YesNoRadio member="isRestrictedToInvestors" meta={{prepopulated: true}}/>
          </div>

          <Collapse in={!context.isRestrictedToInvestors}>
            <div className={styles.section}>
              <Typography variant='h6'>
                Do you intend to only include certain jurisdictions to participate in
                your {isEquity ? 'equity raise' : 'token sale'}?
              </Typography>
              <OptionalInput prepopulated member="isRestrictedToCountries">
                <MultiCountrySelect member="allowedCountries" countries={countries} groups={groups} type='array'/>
              </OptionalInput>
            </div>
          </Collapse>

        </FormContext>
      </ReadOnly>
    )
  }
}

export default Legal